import { useLocation } from 'react-router-dom';

// ─────────────────────────────────────────────────────────────────────────────
// Where the run pages link to. The same pages serve the legacy routes (/runs, /runs/:id, /runs/compare) and the
// Scenario Intelligence workspace's tabs (/evaluation/runs, /evaluation/runs/:id, /evaluation/compare), so a page
// opened inside the workspace keeps its links inside it, and an old bookmark keeps working where it was.
// ─────────────────────────────────────────────────────────────────────────────

export const WORKSPACE_ROOT = '/evaluation';

export const isWorkspacePath = (pathname: string): boolean => pathname === WORKSPACE_ROOT || pathname.startsWith(`${WORKSPACE_ROOT}/`);

export interface RunLinks {
  inWorkspace: boolean;
  /** The runs list. */
  runs: string;
  run: (runId: number) => string;
  /** A comparison by query string (`?baseline=…&candidate=…`). */
  compare: (query: string) => string;
  /** A saved comparison. */
  saved: (comparisonId: number) => string;
}

export function runLinksFor(pathname: string): RunLinks {
  const inWorkspace = isWorkspacePath(pathname);
  const runs = inWorkspace ? `${WORKSPACE_ROOT}/runs` : '/runs';
  const compare = inWorkspace ? `${WORKSPACE_ROOT}/compare` : '/runs/compare';
  return {
    inWorkspace,
    runs,
    run: (runId) => `${runs}/${runId}`,
    compare: (query) => `${compare}${query}`,
    saved: (comparisonId) => `${compare}/${comparisonId}`,
  };
}

/** The run links for the page being shown: inside the workspace when it was opened there. */
export function useRunLinks(): RunLinks {
  return runLinksFor(useLocation().pathname);
}
